import React, { useState } from "react";
import { ViewMoreSupport } from "../../pages";
import { MimaToastUtil } from "../../components";
import constant from "../../utils/constant";
import { SupportController } from "../../controllers";
import * as yup from "yup";

const ViewMoreSupportContainer = ({ closeModal, data }) => {
  const [loading, setLoading] = useState(false);
  const [stage, setStage] = useState("STAGE1");

  const validationSchema = () =>
    yup.object({
      status: yup.string().required("Select status"),
      activity: yup.string().required("Enter comment"),
    });

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      status: values.status,
      activity: values.activity,
    };
    const { status, errorMessage } = await SupportController.updateSupport(
      payload,
      data._id
    );
    if (status === constant.Success) {
      MimaToastUtil.success({ message: "Status updated successfully" });
      setLoading(false);
      return closeModal();
    } else {
      setLoading(false);
      MimaToastUtil.error({ message: errorMessage });
    }
  };

  return (
    <ViewMoreSupport
      closeModal={closeModal}
      data={data}
      loading={loading}
      onSubmit={onSubmit}
      stage={stage}
      setStage={setStage}
      validationSchema={validationSchema}
    />
  );
};
export default ViewMoreSupportContainer;
